import { render, staticRenderFns } from "./BlocoSocioAmbiental.vue?vue&type=template&id=c2dd54a6&scoped=true&lang=pug"
import script from "./BlocoSocioAmbiental.vue?vue&type=script&lang=js"
export * from "./BlocoSocioAmbiental.vue?vue&type=script&lang=js"
import style0 from "./BlocoSocioAmbiental.vue?vue&type=style&index=0&id=c2dd54a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dd54a6",
  null
  
)

export default component.exports